import React, { useState } from "react";
import { Popover } from "react-tiny-popover";
import { NewToolbarButton } from "@shared/Toolbar/NewToolbarButton";
import { MobileActionsPopup } from "./MobileActionsPopup";

export const MobileActionsButton = () => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<Popover
			isOpen={isOpen}
			positions={["bottom", "right"]}
			padding={6}
			content={<MobileActionsPopup onClose={() => setIsOpen(false)} />}
			onClickOutside={() => setIsOpen(false)}
		>
			<div className={"shrink-0"}>
				<NewToolbarButton
					onClick={() => setIsOpen(!isOpen)}
					tooltipMessage={"Map actions"}
					testId={"mobile-actions"}
				>
					<svg width={28} height={28} viewBox={"0 0 24 24"} fill={"none"}>
						<path
							d={"M4 8h10M18 8h2M4 16h2M10 16h10"}
							stroke={"white"}
							strokeWidth={2}
							strokeLinecap={"round"}
						/>
						<circle cx={16} cy={8} r={2.5} stroke={"white"} strokeWidth={2} />
						<circle cx={8} cy={16} r={2.5} stroke={"white"} strokeWidth={2} />
					</svg>
				</NewToolbarButton>
			</div>
		</Popover>
	);
};
